/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {Modal} from 'react-bootstrap'
import {createPortal} from 'react-dom'

type Props = {
  accessToken: string
  show: boolean
  handleClose: () => void
}

const modalsRoot = document.getElementById('root-modals') || document.body
const AccessToken1CModal: FC<Props> = ({accessToken, show, handleClose}) => {
  return createPortal(
    <Modal show={show} onHide={handleClose} size='lg' centered>
      <Modal.Header closeButton>
        <Modal.Title>Token for 1C</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <code className='text-gray-700'>{accessToken}</code>
      </Modal.Body>
    </Modal>,
    modalsRoot
  )
}

export {AccessToken1CModal}
